import { render, staticRenderFns } from "./TheSettingsToolBar.vue?vue&type=template&id=1e68545e&scoped=true"
import script from "./TheSettingsToolBar.vue?vue&type=script&lang=js"
export * from "./TheSettingsToolBar.vue?vue&type=script&lang=js"
import style0 from "./TheSettingsToolBar.vue?vue&type=style&index=0&id=1e68545e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e68545e",
  null
  
)

export default component.exports